export default __webpack_public_path__ + "static/media/logo.9bb8f277.png";